const filterByModel = (selection) => {
  switch (selection) {
    case "grupo 1":
      return data.modelo.grupo_1;
    case "grupo 2":
      return data.modelo.grupo_2;
  }
};
const filterByHeight = (obj, selection) => {
  switch (selection) {
    case "1.74":
      return obj.altura["<1.75"];
    case "1.78":
      return obj.altura["<1.80"];
    case "1.82":
      return obj.altura["<1.85"];
    case "1.88":
      return obj.altura["<1.90"];
    case "1.92":
      return obj.altura[">=1.90"];
  }
};
const filterByShape = (obj, selection) => {
  switch (selection) {
    case "delgado":
      return obj.forma["delgado"];
    case "dad bod":
      return obj.forma["dad_bod"];
    case "normal":
      return obj.forma["normal"];
    case "musculoso":
      return obj.forma["musculoso"];
    case "poco sobrepeso":
      return obj.forma["poco_sobrepeso"];
    case "sobrepeso":
      return obj.forma["sobrepeso"];
  }
};
const filterByFitment = (obj, selection) => {
  switch (selection) {
    case "ajustada":
      return obj.calce["ajustado"];
    case "normal":
      return obj.calce["regular"];
    case "holgada":
      return obj.calce["suelto"];
  }
};

function calcularTalla() {
  const altura = document.getElementById("altura").value;
  const forma = document.getElementById("tipoCuerpo").value;
  const calce = document.getElementById("estrechez").value;
  const modelo = document.getElementById("modelo").value;

  const filteredByModel = filterByModel(modelo);
  const filteredByHeight = filterByHeight(filteredByModel, altura);
  const filteredByShape = filterByShape(filteredByHeight, forma);
  const filteredByFitment = filterByFitment(filteredByShape, calce);

  console.log("fitment", filteredByFitment);

  // Aquí puedes implementar la lógica para calcular la talla
  // Puedes usar estos valores para mostrar en el resultado de manera ficticia
  const resultado = `Tu talla es ${filteredByFitment.talla}`;

  document.getElementById("resultado").innerHTML = resultado;
}
